var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-movimentacao" }, [
    _vm._m(0),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "select" },
      [
        _c("v-autocomplete", {
          staticClass: "input",
          attrs: {
            items: _vm.userList,
            "no-data-text": "Sem registros",
            "item-text": "title2",
            "return-object": "",
            "item-value": "id",
            "menu-props": { bottom: true, offsetY: true },
            placeholder: "Selecione um ativo existente",
            color: "secondary",
            required: "",
            outlined: "",
            rounded: ""
          },
          on: {
            change: function($event) {
              return _vm.changeAtivo($event)
            }
          },
          model: {
            value: _vm.ativo,
            callback: function($$v) {
              _vm.ativo = $$v
            },
            expression: "ativo"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("Consultar movimentação de ativo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtitle" }, [
      _c("span", [_vm._v("Escolha um ativo para visualizar a movimentação")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }